import React, { useEffect , useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import { Button, Card, Col, Row, Table, Pagination,  Modal , Tag  } from "antd";
import Filter from "../../../components/filter/Filter";
import { deleteUser, getUsersList } from "../../../redux/slices/users/usersThunk";

const UsersPage = () => {
  const [filter, setFilter] = useState({
    search: "",
    speciality: "",
    location: "",
    type: "",
    phone: "",
    email: "",
    pagination: 1,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsersList({ page: filter.pagination, itemsPerPage: 10, filter }));
  }
  , [dispatch, filter]);
  
  const usersData = useSelector((state) => state.users.usersList.data.data); 
  const totalItems = useSelector((state) => state.users.usersList?.data?.total);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemId, setCitemId] = useState(null);

  const showModal = (id) => {
    setIsModalOpen(true);
    setCitemId(id);
  };


  const optionsLists = [
    {
      name: "Role",
      placeholder: "role",
      key: "role",
      options: [
        { label: "Administrateur", value: "administrateur" },
        { label: "Superviseur", value: "superviseur" },
        { label: "Commercial", value: "commercial" },
        { label: "Délégué", value: "délégué" },
      ],
    },
    {
      name: "Statut",
      placeholder: "Statut",
      key: "status",
      options: [
        { label: "Actif", value : true },
        { label: "inactif", value : false },
      ],
    },
  ];
  

  const handlePagination = (page) => {
    setFilter(prev => ({ ...prev, pagination: page }));
  };


  const history = useHistory();

  const naviagteTo = (path) => {
    history.push(path);
  };

  const handelDelete = (id) => {
      dispatch(deleteUser(id));
      setIsModalOpen(false);
  }

  const columns = [
    {
      title: "Nom",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Prénom",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Mot de passe",
      dataIndex: "password",
      key : "password",
    },
    {
      title: "Téléphone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Role",
      dataIndex: ["role","name"],
      key: "role",
    },
    {
      title: "Statut",
      dataIndex: ["status","name"],
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red" }>{status}</Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <>
          <Button type="link" className="darkbtn"
            onClick={() => naviagteTo(`edit/utilisateur/${record.id}`)}
          >
            <EditOutlined /> Modifier
          </Button>
          <Button type="link" danger onClick={() => showModal(record.id)}>
            <DeleteOutlined /> Supprimer
          </Button>
        </>
      ),
    },
  ];
  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Liste des utilisateurs"
            extra={
              <React.Fragment>
                <Button
                  type="primary"
                  onClick={() => naviagteTo("/nouveau/utilisateur")}
                >
                  <PlusOutlined />
                  Ajouter un utilisateur
                </Button>
              </React.Fragment>
            }
          />
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={
              <Filter
                searchPlaceholder="Rechercher"
                optionsLists={optionsLists}
                setFilter={setFilter}
                data={filter}
              />
            }
          >
            <Table
              columns={columns}
              dataSource={usersData}
              className="ant-border-space"
              pagination={false}
              scroll={{ x: 240 }}
              rowKey={(record) => record.id}
            />
          </Card>
          <Pagination
            current={filter.pagination}
            total={totalItems}
            pageSize={10}
            onChange={handlePagination}
          />
        </Col>
        <Modal
        title="Supprimer une région"
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="back" onClick={() => setIsModalOpen(false)}>
            Annuler
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => handelDelete(itemId)}
          >
            Supprimer
          </Button>,
        ]}
      >
        <p>Êtes-vous sûr de vouloir supprimer cet utilisateur ? </p>
      </Modal>
      </Row>
    </div>
  );
};

export default UsersPage;
